type PlotlyColor = [number, string];

/**
 * Port of thermoimaging.colormap_schwarzgraueisen.generate_temp_color_map + matplotlib_to_plotly.
 * Accepts maxTemp (data max) and minValidTemp (typically 600) to build the gradient with the purple band.
 */
export function generateTempColorscale(maxTemp: number, minValidTemp: number): PlotlyColor[] {
  if (!Number.isFinite(maxTemp) || maxTemp <= 0) {
    return [[0, "rgb(255,255,255)"], [1, "rgb(255,255,255)"]];
  }

  const minValidPosition = (1 - minValidTemp / maxTemp) * 100;
  const stops = [
    { pos: 0, rgb: [255, 255, 255] },
    { pos: minValidPosition - (4 * minValidPosition) / 5, rgb: [253, 252, 111] },
    { pos: minValidPosition - (3 * minValidPosition) / 5, rgb: [246, 118, 20] },
    { pos: minValidPosition - (2 * minValidPosition) / 5, rgb: [240, 43, 44] },
    { pos: minValidPosition - (1 * minValidPosition) / 5, rgb: [113, 0, 124] },
    { pos: minValidPosition, rgb: [78, 43, 82] },
    { pos: minValidPosition + (1 * (100 - minValidPosition)) / 4, rgb: [228, 228, 228] },
    { pos: minValidPosition + (2 * (100 - minValidPosition)) / 4, rgb: [170, 170, 170] },
    { pos: minValidPosition + (3 * (100 - minValidPosition)) / 4, rgb: [111, 111, 111] }
  ];

  const positions = stops.map((s) => s.pos / 100);
  const colors = stops.map((s) => s.rgb);

  const normPositions = [...positions];
  const normColors = [...colors];
  if (normPositions[0] !== 0) {
    normPositions.unshift(0);
    normColors.unshift(colors[0]);
  }
  if (normPositions[normPositions.length - 1] !== 1) {
    normPositions.push(1);
    normColors.push(colors[colors.length - 1]);
  }

  const colorscale: PlotlyColor[] = normPositions.map((p, idx) => {
    const c = normColors[idx];
    return [p, `rgb(${c[0]}, ${c[1]}, ${c[2]})`];
  });

  // Reverse to match Python .reversed()
  return colorscale
    .slice()
    .reverse()
    .map(([p, color]) => [1 - p, color]);
}
